module.exports = __webpack_public_path__ + "static/images/download-on-app-store.ff9b8157347c1c5be61c6332ac5bf885.png";